module.exports = __webpack_public_path__ + "static/media/img3.4393f95c.jpeg";